// extracted by mini-css-extract-plugin
export var aircallIframe = "_e7-3";
export var fabContainer = "_e7-5";
export var fabRinging = "_e7-6";
export var loadingOverlay = "_e7-4";
export var pulse = "_e7-7";
export var widgetContent = "_e7-2";
export var widgetPanel = "_e7-0";
export var widgetPanelExpanded = "_e7-1";